<template>
  <el-dialog
    @close="handleClose"
    :modal-append-to-body="false"
    width="965px"
    :visible.sync="dialogFormVisible"
  >
    <!-- 询盘和供需 -->
    <el-form :model="demand" :rules="rules" ref="demand" label-width="170px">
      <el-form-item :label="$t('Trade') + '：'">
        <el-select
          v-model="demand.type"
          placeholder="采购/供应"
          style="width: 70%"
        >
          <el-option label="采购" value="DEMAND"></el-option>
          <el-option label="供应" value="SUPPLY"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('Title') + '：'" required>
        <el-input
          style="width: 70%"
          v-model="demand.title"
          :placeholder="'请填写您的需求标题！'"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Products Category2') + '：'">
        <el-select
          v-model="categoryId"
          :placeholder="$t('Please choose Products Category')"
          style="width: 70%"
        >
          <el-option
            v-for="item in exhibitCategories"
            :key="item.id"
            :label="$i18n.locale == 'zh' ? `${item.name}` : `${item.nameEn}`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('Inquired Quantity') + '：'" required>
        <el-input-number
          v-model="demand.quantity"
          :min="1"
          :max="1000"
          label="请选择询盘数量"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('Delivery Period') + '：'">
        <el-form-item prop="tradingTime">
          <el-date-picker
            :value-format="'timestamp'"
            type="date"
            :placeholder="$t('Year/Month/Day')"
            v-model="demand.tradingTime"
            style="width: 65%"
          ></el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item
        :label="$t('Trade Content') + '：'"
        prop="description"
        required
      >
        <el-input
          type="textarea"
          style="width: 70%"
          v-model="demand.description"
          :placeholder="
            $t(
              'Please leave your description so that the enterprise can confirm the reservation information with you!'
            )
          "
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Contact Information') + '：'" required>
        <el-col :span="7">
          <el-form-item prop="contactName">
            <el-input
              style="width: 190px"
              :placeholder="$t('Mr./Ms.')"
              v-model="demand.contactName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactNumber">
            <el-input
              style="width: 190px"
              :placeholder="$t('Your Phone')"
              v-model="demand.contactNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="contactEmail">
            <el-input
              style="width: 260px"
              :placeholder="$t('Your E-mail')"
              v-model="demand.contactEmail"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Company1') + '：'" prop="company">
        <el-input
          style="width: 300px"
          :placeholder="$t('Your Company')"
          v-model="demand.companyName"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="primary"
          style="width: 220px"
          @click="submitForm('demand')"
          >{{ $t("SUBMIT") }}</el-button
        >
      </el-form-item>
      <div class="ask-img-box row-center">
        <el-upload
          class="avatar-uploader"
          action="https://api.e-chinacycle.com/oss/file"
          :show-file-list="false"
          :headers="myHeaders"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <div
            style="
              width: 120px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            class="row"
            v-if="demand.picture"
          >
            <img :src="demand.picture" class="avatar" />
          </div>
          <div v-else>参考图片</div>
          <div class="upload-btn">上传图片</div>
        </el-upload>
        <!-- <img src="https://via.placeholder.com/177x163.png" /> -->
      </div>
    </el-form>
    <div slot="title" class="dialog-header">
      <div class="row-between dialog-header-box">
        <p
          class="dialog-header-title"
          :style="$i18n.locale == 'zh' ? '' : 'font-size:15px;'"
        >
          {{ $t("Publish Transaction") }}
        </p>
        <p class="dialog-header-description">
          {{
            $t(
              "Please leave your description so that the enterprise can confirm the reservation information with you!"
            )
          }}
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { publish, enquiry, getExhibitDetail } from "@/http/api";

import { checkPhoneValid, checkEmailValid } from "@/libs/utils";

export default {
  data() {
    return {
      categoryId: "",
      demand: {
        picture: "",
        type: "DEMAND",
        quantity: 0,
        description: "",
        contactName: "",
        contactNumber: "",
        companyName: ""
      },
      rules: {
        type: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        contactName: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ],
        // contactNumber: [
        //   { required: true, message: "请填写联系电话", trigger: "blur" }
        // ],
        contactNumber: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "" || value === undefined || value === null) {
                callback();
              } else if (!checkPhoneValid(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        contactEmail: [
          {
            validator: (rule, value, callback) => {
              if (value === "" || value === undefined || value === null) {
                callback();
              } else if (!checkEmailValid(value)) {
                callback(new Error("请输入正确的邮箱"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        companyName: [
          { required: true, message: "请填写公司名称", trigger: "blur" }
        ],
        quantity: [
          { required: true, message: "请填写采购数量", trigger: "blur" }
        ],
        description: [
          { required: true, message: "请填写需求描述", trigger: "blur" }
        ],
        picture: [{ required: true, message: "请上传图片", trigger: "change" }]
      },
      formLabelWidth: "120px",
      exhibitionInfo: {
        exhibitor: {
          name: ""
        },
        properties: {
          alubms: []
        }
      },
      myHeaders: {
        Authorization: "Bearer " + localStorage.getItem("token")
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      exhibitCategories: state => state.exhibitCategories.toTree()
    })
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.demand.picture = res.url;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },

    async submitForm(formName) {
      console.log(this.$refs[formName]);
      console.log(this.$refs[formName].valid);
      this.$refs[formName].validate(async valid => {
        debugger;
        console.log(valid);
        try {
          if (valid) {
            this.demand.user = { id: this.user.id };

            if (this.categoryId) {
              this.demand.category = { id: this.categoryId };
            }

            await publish(this.demand);

            this.$emit("handleCloseDialog", false);
          } else {
            console.log("error submit!!");
            return false;
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
    handleClose() {
      // this.submitForm
      this.$emit("handleCloseDialog", false);
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__headerbtn {
  border: 1px solid #aaa;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  line-height: 20px;
}
.dialog-header-box {
  border-bottom: 1px solid #aaaaaa;
  .dialog-header-title {
    font-size: 30px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    border-bottom: 2px solid #619a37;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .dialog-header-description {
    font-size: 14px;
    font-family: FZLanTingHei-R-GBK;
    font-weight: 400;
    color: #999999;
  }
}
/deep/ .el-dialog__header {
  padding: 20px 80px 10px;
}
/deep/ .el-dialog__body {
  padding: 30px 80px;
}
/deep/ .el-button--primary {
  background-color: #619a37;
  border-color: unset;
}
.ask-img-box {
  position: absolute;
  right: 115px;
  top: 120px;
  width: 120px;
  height: 120px;
  border: 1px solid #ddd;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.upload-btn {
  position: absolute;
  bottom: -40px;
  left: 17px;
  font-size: 16px;
  background: #619a37;
  color: #fff;
  padding: 0 10px;
}
.avatar-uploader {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/supplydialog.vue